import '../Styles/ourpartner.css';

const institutionLogos = [
  {
    src: '/assets/New_prince_Logo.png',
    alt: 'New Prince',
    className: 'logo-new-prince',
  },

  {
    src: '/assets/Excel_logo.png',
    alt: 'Excel',
    className: 'logo-excel',
  },

  {
    src: '/assets/Peri_logo.png',
    alt: 'PERI',
    className: 'logo-peri',
  },
  {
    src: '/assets/Kalasalingam_logo.png',
    alt: 'Kalasalingam',
    className: 'logo-kalasalingam',
  },
];

const corporateLogos = [
  {
    src: '/assets/Inypeople_logo.png',
    alt: 'Inypeople',
    className: 'logo-inypeople',
  },
  {
    src: '/assets/Touch,ark_logo.png',
    alt: 'Touchmark',
    className: 'logo-touchmark',
  },
];

function OurPartners() {
  return (
    <>
      {/* ===== SECTION 1 ===== */}
      <section className="partners-hero">
        <div className="partners-hero-content">
          <h1 className="partners-heading">
            Can you provide me with{' '}
            <span className="partners-highlight">
              some details about your company
            </span>
            , such as what it does, its mission, and any unique aspects?
          </h1>

          <button className="partners-btn">
            Let's Collaborate
            <img
              src="/assets/home_arrow_icon.png"
              alt="Arrow"
              className="partners-arrow-icon"
            />
          </button>
        </div>
      </section>

      {/* ===== SECTION 2 ===== */}
      <section className="institution-section">
        <h2 className="partners-section-heading">Institution Partners</h2>
        <div className="partners-underline"></div>

        <div className="institution-logos-row">
          {institutionLogos.map((logo, index) => (
            <div className="institution-logo-item" key={index}>
              <img
                src={logo.src}
                alt={logo.alt}
                className={`institution-logo-img ${logo.className}`}
              />
            </div>
          ))}
        </div>

        {/* ===== SECTION 3 ===== */}
        <h2 className="partners-section-heading corporate-heading">
          Corporate Partners
        </h2>

        <div className="partners-underline"></div>

        <div className="corporate-logos-row">
          {corporateLogos.map((logo, index) => (
            <div className="corporate-logo-item" key={index}>
              <img
                src={logo.src}
                alt={logo.alt}
                className={`corporate-logo-img ${logo.className}`}
              />
            </div>
          ))}
        </div>
      </section>
    </>
  );
}

export default OurPartners;